import React from "react";
import PropTypes from "prop-types";
import Loadable from "react-loadable";
import { hot } from "react-hot-loader";

import { getCookie, setCookie, detectBrowser } from "lib/loginHelpers.js";

import Login from "layout/Login";
import projectList from "config/projectList.js";

import { SetupLoader } from "loaders";

class LoginController extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			projectCookie: null,
		};
	}
	componentDidMount() {
		const projectCookie = getCookie("project");
		// Make sure the project has been deployed on this branch
		if (projectCookie && projectList[projectCookie]) {
			// setCookie("project", this.props.currentProject);
			this.setState({
				projectCookie,
			});
		}
		this.props.checkForCurrentSession(projectCookie);

		// Browser detection
		this.props.setBrowserType(detectBrowser());
	}

	render() {
		const { props, state } = this;
		// console.log("LoginController", props.loggedIn);

		return (
			<div
				className={`login-controller ${props.currentProject || ""} ${
					props.currentProject === "sevenTwenty_uscc" || props.currentProject === "bcbs"
						? "sevenTwenty"
						: ""
				}`}
			>
				{props.checkedForExistingUserOnLoad &&
					(!props.loggedIn ? (
						<Login lastProject={state.projectCookie} />
					) : (
						<SetupLoader currentProject={props.currentProject} />
					))}
			</div>
		);
	}
}

LoginController.propTypes = {
	checkedForExistingUserOnLoad: PropTypes.bool.isRequired,
	checkForCurrentSession: PropTypes.func.isRequired,
	loggedIn: PropTypes.bool.isRequired,
	currentProject: PropTypes.string,
	setBrowserType: PropTypes.func.isRequired,
};

export default hot(module)(LoginController);
